module.exports = __webpack_public_path__ + "static/media/hoppe.48f13a16.m4a";